import { Link } from 'react-router-dom';
import { Square3Stack3DIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { PageHeader } from '../../components/PageHeader';
import { Button } from '../../catalyst/button';

export function Header({
  categoryId,
  categoryName,
  clusterId,
  prevClusterId,
  nextClusterId,
}: {
  categoryId: number | undefined;
  categoryName: string | undefined;
  clusterId: string;
  prevClusterId: number | null;
  nextClusterId: number | null;
}) {
  return (
    <div className="mb-4">
      <nav aria-label="Breadcrumb" className="mb-2 flex items-center gap-1 text-sm text-gray-500 dark:text-zinc-400">
        <Link to="/categories" className="hover:text-gray-700 dark:hover:text-zinc-200">
          Categories
        </Link>
        <ChevronRightIcon className="size-4 shrink-0" />
        {categoryId != null ? (
          <Link to={`/categories/${categoryId}`} className="hover:text-gray-700 dark:hover:text-zinc-200">
            {categoryName ?? `Category ${categoryId}`}
          </Link>
        ) : (
          <span>{categoryName ?? 'Category'}</span>
        )}
        <ChevronRightIcon className="size-4 shrink-0" />
        <span aria-current="page" className="text-gray-700 dark:text-zinc-200">
          Cluster #{clusterId}
        </span>
      </nav>

      <PageHeader
        title={`${categoryName ?? 'Cluster'} — Cluster #${clusterId}`}
        description="Inspect and curate a single embedding cluster"
        icon={<Square3Stack3DIcon className="size-6" />}
        showBackButton={true}
      >
        <div className="flex items-center gap-2 whitespace-nowrap">
          {/* Spread href only when navigable: Catalyst Button renders a real
              disabled <button> when no href key is present, but a still-clickable
              <Link to={undefined}> if href is passed as undefined. */}
          <Button outline disabled={prevClusterId == null} {...(prevClusterId != null ? { href: `/category-clusters/${prevClusterId}` } : {})}>
            <ChevronLeftIcon className="size-4" /> Prev
          </Button>
          <Button outline disabled={nextClusterId == null} {...(nextClusterId != null ? { href: `/category-clusters/${nextClusterId}` } : {})}>
            Next <ChevronRightIcon className="size-4" />
          </Button>
          {categoryId != null && (
            <Button outline href={`/categories/${categoryId}`}>
              Open category
            </Button>
          )}
        </div>
      </PageHeader>
    </div>
  );
}
